module.exports = __webpack_public_path__ + "static/img/img02.69b822d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aifv/img02.png
// module id = 31bl
// module chunks = 1